import axios from '@/libs/api.request'
import config from '@/config'

const opscenterBaseUrl = config.baseOpsCenterUrl + '/api/v1/'

// 取guacamole token
export const getGuacamoleToken = () => {
  return axios.request({
    url: opscenterBaseUrl + 'guacamole/token',
    method: 'post'
  })
}

export const getOpsCenterServerGroup = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_group/',
    method: 'get'
  })
}

export const getOpsCenterServerGroupHost = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_group_host/',
    method: 'get'
  })
}

export const getOpsCenterServerGroupHostMine = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_group_host_mine/',
    method: 'get'
  })
}

export const detailOpsCenterServerGroup = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_group/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterServerGroup = (data, id) => {
  let url = opscenterBaseUrl + 'server_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterServerGroup = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_group/' + id + '/',
    method: 'delete'
  })
}

export const getOpsCenterSupport = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'support/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllSupport = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_support_list/',
    params: params,
    method: 'get'
  })
}

export const detailOpsCenterSupport = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'support/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterSupport = (data, id) => {
  let url = opscenterBaseUrl + 'support/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterSupport = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'support/' + id + '/',
    method: 'delete'
  })
}

export const getOpsCenterServer = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllServer = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_server_list/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllScanServer = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_server_list_scan/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterSelAllServer = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_server_sel_list/',
    params: params,
    method: 'get'
  })
}

export const detailOpsCenterServer = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterServer = (data, id) => {
  let url = opscenterBaseUrl + 'server/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterServer = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/' + id + '/',
    method: 'delete'
  })
}

export const getOpsCenterCertificate = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'certificate/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllCertificate = () => {
  return axios.request({
    url: opscenterBaseUrl + 'all_certificate_list/',
    method: 'get'
  })
}

export const detailOpsCenterCertificate = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'certificate/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterCertificate = (data, id) => {
  let url = opscenterBaseUrl + 'certificate/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterCertificate = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'certificate/' + id + '/',
    method: 'delete'
  })
}

export const getOpsCenterProtocol = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'protocol/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllProtocol = () => {
  return axios.request({
    url: opscenterBaseUrl + 'all_protocol_list/',
    method: 'get'
  })
}

export const detailOpsCenterProtocol = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'protocol/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterProtocol = (data, id) => {
  let url = opscenterBaseUrl + 'protocol/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterProtocol = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'protocol/' + id + '/',
    method: 'delete'
  })
}

export const getRegion = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server/region',
    method: 'get'
  })
}

export const collectServer = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/collect_instances',
    data: data,
    method: 'post'
  })
}

export const getContentTypeId = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'get_content_type_id',
    params: params,
    method: 'get'
  })
}

export const getRevisionLogs = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'revision_logs_list/',
    params: params,
    method: 'get'
  })
}

export const UnlockCertificateKey = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'unlock_key',
    params: params,
    method: 'get'
  })
}

export const getUnlockLogs = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'unlock_logs_list/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterScript = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'script/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterAllScript = () => {
  return axios.request({
    url: opscenterBaseUrl + 'all_script_list/',
    method: 'get'
  })
}

export const detailOpsCenterScript = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'script/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterScript = (data, id) => {
  let url = opscenterBaseUrl + 'script/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterScript = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'script/' + id + '/',
    method: 'delete'
  })
}

export const scriptExecApi = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'script_exec',
    data: data,
    method: 'post'
  })
}

export const getScriptExecLogs = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'script_exec_logs_list/',
    params: params,
    method: 'get'
  })
}

export const detailScriptExecLogs = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'script_exec_logs_list/' + id + '/',
    method: 'get'
  })
}

export const getScriptExecAllLogs = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'script_exec_logs_all_list/',
    params: params,
    method: 'get'
  })
}

export const getScriptVersionHistory = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'script_history_list/',
    params: params,
    method: 'get'
  })
}

export const getOpsCenterCron = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron/',
    params: params,
    method: 'get'
  })
}

export const detailOpsCenterCron = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterCron = (data, id) => {
  let url = opscenterBaseUrl + 'cron/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterCron = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron/' + id + '/',
    method: 'delete'
  })
}

export const cronBindServerApi = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron_bind_server',
    data: data,
    method: 'post'
  })
}

export const cronUnbindServerApi = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron_unbind_server',
    data: data,
    method: 'post'
  })
}

export const getCronOperationLogsList = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron_operation_logs_list/',
    params: params,
    method: 'get'
  })
}

export const getCronBindServerList = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'cron_bind_server_list/',
    params: params,
    method: 'get'
  })
}

// 统计 总数量/运行中/即将过期/已过期主机数量
export const getServerAmount = () => {
  return axios.request({
    url: opscenterBaseUrl + 'get_server_amount/',
    method: 'get'
  })
}

// 获取主机磁盘信息列表
export const getHostDiskList = (id, params) => {
  return axios.request({
    url: opscenterBaseUrl + 'host/' + id + '/diskinfo',
    params: params,
    method: 'get'
  })
}

// 获取主机用户信息列表
export const getHostUsersList = (id, params) => {
  return axios.request({
    url: opscenterBaseUrl + 'host/' + id + '/userinfo',
    params: params,
    method: 'get'
  })
}

// 获取用户有权限的主机列表（凭证关联用户，主机关联凭证）
export const getUserHostPerm = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'host/perm',
    params: params,
    method: 'get'
  })
}

// 用户选择 凭证用户 连接主机的时候创建guacamole连接，返回connectId
export const getConnectId = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'connect/create',
    data: data,
    method: 'post'
  })
}

// opscenter 数据权限分配
export const opscenterRoleData = (data) => {
  let url = opscenterBaseUrl + 'role/data'
  return axios.request({
    url: url,
    data: data,
    method: 'put'
  })
}

// Agent server 列表
export const getAgentServer = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_agent/',
    params: params,
    method: 'get'
  })
}

// Agent列表
export const getAgentList = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/',
    params: params,
    method: 'get'
  })
}

// 创建Agent
export const saveAgent = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/',
    data: data,
    method: 'post'
  })
}

// 删除Agent
export const deleteAgent = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/' + id + '/',
    method: 'delete'
  })
}

// 安装 Agent 到所选目标机器
export const installAgent = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/install',
    data: data,
    method: 'post'
  })
}

// Agent 操作日志列表
export const getAgentLogs = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent_log/',
    params: params,
    method: 'get'
  })
}

// 升级 所选目标机器 的 Agent
export const updateAgent = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/update',
    data: data,
    method: 'post'
  })
}

// 卸载 所选目标机器 的 Agent
export const unInstallAgent = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'agent/uninstall',
    data: data,
    method: 'post'
  })
}

// 扫描主机或者其他设备
export const scanServer = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/scan_instances',
    data: data,
    method: 'post'
  })
}

// 扫描主机或者其他设备
export const scanHostName = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/scan_hostnames',
    data: data,
    method: 'post'
  })
}

// 扫描主机或者其他设备
export const scanServerOk = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'server/scan_instances_ok',
    data: data,
    method: 'post'
  })
}

// 获取所有扫描主机临时表数据
export const getAllScanTmp = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'scan_tmp/',
    params: params,
    method: 'get'
  })
}

// 作业 ↓4
export const getOpsCenterJob = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'job/',
    params: params,
    method: 'get'
  })
}

export const detailOpsCenterJob = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'job/' + id + '/',
    method: 'get'
  })
}

export const changeOpsCenterJob = (data, id) => {
  let url = opscenterBaseUrl + 'job/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteOpsCenterJob = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'job/' + id + '/',
    method: 'delete'
  })
}

// 获取作业步骤 ↓1
export const getOpsCenterJobSteps = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'job_step/',
    params: params,
    method: 'get'
  })
}

// 提交作业步骤 ↓1
export const updateOpsCenterJobStep = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'job_step_update/',
    traditional: true,
    data: data,
    method: 'post'
  })
}

// 作业执行日志 ↓3
export const getOpsCenterJobExecLog = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'job_exec_log/',
    params: params,
    method: 'get'
  })
}

export const detailOpsCenterJobExecLog = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'job_exec_log/' + id + '/',
    method: 'get'
  })
}

export const getOpsCenterJobUnfinishedExecLog = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'unfinished_exec_log/',
    params: params,
    method: 'get'
  })
}

// 执行作业 ↓1
export const execOpsCenterJob = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'exec_job/',
    traditional: true,
    data: data,
    method: 'post'
  })
}

// 结束作业
export const overOpsCenterJob = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'over_job/',
    data: data,
    method: 'post'
  })
}

// 服务器列表显示列 ↓2
export const getServerTableCol = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_table_col/',
    method: 'get'
  })
}

export const postServerTableCol = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_table_col/',
    data: data,
    method: 'post'
  })
}

// 域名管理
export const getAllDomains = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_domain_list/',
    params: params,
    method: 'get'
  })
}

export const getAllDomainAccounts = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'all_domain_account_list/',
    params: params,
    method: 'get'
  })
}

export const getDomains = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'domain_list/',
    params: params,
    method: 'get'
  })
}

export const createDnsRecord = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'add_dns/',
    data: data,
    method: 'post'
  })
}

export const checkDnsRecord = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'check_dns/',
    data: data,
    method: 'post'
  })
}

export const checkDnsRecordBatch = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'check_dns_batch/',
    data: data,
    method: 'post'
  })
}

export const createDnsRecordBatch = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'add_dns_batch/',
    data: data,
    method: 'post'
  })
}

export const purchaseDomain = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'purchase_domain/',
    data: data,
    method: 'post'
  })
}

export const getDomainResolves = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'get_domain_resolves/',
    params: params,
    method: 'get'
  })
}

// 域名DASHBOARD 列表
export const getDomainLst = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'board_domain_list/',
    params: params,
    method: 'get'
  })
}

// 域名DASHBOARD 按平台统计api
export const getDomainPlatform = () => {
  return axios.request({
    url: opscenterBaseUrl + 'domain_show_platform/',
    method: 'get'
  })
}

// 域名DASHBOARD 即将过期域名列表
export const getDomainExpire = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'domain_show_expire/',
    params: params,
    method: 'get'
  })
}

// 域名DASHBOARD 按账号统计
export const getDomainAccount = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'domain_show_account/',
    params: params,
    method: 'get'
  })
}

// 主机DASHBOARD 按账号统计
export const getServerAccount = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_account/',
    params: params,
    method: 'get'
  })
}

// 主机DASHBOARD 即将过期的主机列表
export const getServerExpire = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_expire/',
    params: params,
    method: 'get'
  })
}

// 获取主机报表分平台统计主机数量api
export const getServerPlatform = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_platform/',
    method: 'get'
  })
}

// 主机DASHBOARD 操作系统的主机列表
export const getServerOs = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_os/',
    method: 'get'
  })
}

// 按物理机 云主机类型获取主机数量api
export const getServerType = () => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_type/',
    method: 'get'
  })
}

// 获取主机报表分地域主机数量api
export const getServerRegion = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_show_region/',
    params: params,
    method: 'get'
  })
}

// 获取费用报表按平台展示 不同平台月度费用情况
export const getServerCostPlatform = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_cost_platform/',
    params: params,
    method: 'get'
  })
}

// 获取费用报表按账号展示当前选择平台下 不同账号月度费用情况
export const getServerCostAccount = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_cost_account/',
    params: params,
    method: 'get'
  })
}

// 获取费用报表按账号展示当前选择平台下 不同账号 不同 产品类型月度费用情况
export const getServerCostProduct = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_cost_product/',
    params: params,
    method: 'get'
  })
}

// 获取费用报表按账号展示当前选择平台下 不同账号 不同 产品类型月度费用情况
export const getServerCostProductMon = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_cost_product_mon/',
    params: params,
    method: 'get'
  })
}

// 获取费用报表按账号展示当前选择平台下 不同账号 不同 产品类型月度费用情况
export const getServerCostPlatformMon = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'server_cost_platform_mon/',
    params: params,
    method: 'get'
  })
}

// 手动同步域名
export const SyncDomain = () => {
  return axios.request({
    url: opscenterBaseUrl + 'sync_domain/',
    method: 'post'
  })
}

// 手动同步费用
export const SyncCost = () => {
  return axios.request({
    url: opscenterBaseUrl + 'sync_cost/',
    method: 'post'
  })
}

// 获取主机组织结构数据
export const getServerOrg = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'get_server_tree_list/',
    params: params,
    method: 'get'
  })
}

// 百度站点分析
export const getAnalyseSiteList = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'analyse_site/',
    params: params,
    method: 'get'
  })
}

export const getAnalyseSiteCount = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'analyse_site_count/',
    params: params,
    method: 'get'
  })
}

export const getAnalyseSiteCountCommon = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'analyse_site_count/overview_common/',
    params: params,
    method: 'get'
  })
}

// 佰易浏览器分析
export const getBaiYiBrowserAnalyseSite = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'baiyi_browser_site/',
    params: params,
    method: 'get'
  })
}

// 佰易客服分析
export const getBaiYiSaturnAnalyseSite = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'baiyi_saturn_site/',
    params: params,
    method: 'get'
  })
}

// 北极星分析
export const getPolarisBaseAnalyseSite = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'polaris_base_site/',
    params: params,
    method: 'get'
  })
}

// HunterBrowser
export const uploadHunterBrowserDataUrl = opscenterBaseUrl + 'hunter_browser/upload/'

export const getHunterBrowser = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/',
    params: params,
    method: 'get'
  })
}

export const getHunterBrowserAll = (params) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser_all/',
    params: params,
    method: 'get'
  })
}

export const changeHunterBrowser = (data, id) => {
  let url = opscenterBaseUrl + 'hunter_browser/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteHunterBrowser = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/' + id + '/',
    method: 'delete'
  })
}

export const hunterBrowserTestConn = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/' + id + '/test_conn/',
    method: 'get'
  })
}

export const hunterBrowserCheckBindStatus = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/' + id + '/check_bind_status/',
    method: 'get'
  })
}

export const hunterBrowserDeploy = (id) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/' + id + '/deploy/',
    method: 'post'
  })
}

export const hunterBrowserBatchDeploy = (data) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/batch_deploy/',
    data: data,
    method: 'post'
  })
}

export const hunterBrowserRestartService = (id, data) => {
  return axios.request({
    url: opscenterBaseUrl + 'hunter_browser/' + id + '/restart_service/',
    data: data,
    method: 'post'
  })
}
